import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/material';

export const LoadingComments = () => {
    return (
        <>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Skeleton variant="circular" width={45} height={45} />

                <Box
                    sx={{
                        bgcolor: '#f0f0f0',
                        borderRadius: '15px',
                        padding: 1.5,
                        width: 250,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                    }}
                >
                    <Skeleton variant="rectangular" width="100%" height={20} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 1 }} />
                </Box>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Skeleton variant="circular" width={45} height={45} />

                <Box
                    sx={{
                        bgcolor: '#f0f0f0',
                        borderRadius: '15px',
                        padding: 1.5,
                        width: 250,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                    }}
                >
                    <Skeleton variant="rectangular" width="100%" height={20} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 1 }} />
                </Box>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Skeleton variant="circular" width={45} height={45} />

                <Box
                    sx={{
                        bgcolor: '#f0f0f0',
                        borderRadius: '15px',
                        padding: 1.5,
                        width: 250,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                    }}
                >
                    <Skeleton variant="rectangular" width="100%" height={20} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 1 }} />
                </Box>
            </Stack>
        </>
    );
}

/*
 <Stack spacing={2}>
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="text" width={210} height={40} />
      <Skeleton variant="rectangular" width={210} height={118} />
    </Stack>
*/